<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <v-layout row wrap>
            <v-flex xs3>
                <LeftAdminBar />
            </v-flex>
            <v-flex xs9>
                <v-flex xs12> 
                    <v-card class="shadow-none" outlined >  
                    <language-list v-bind:ltype="0"></language-list>
                </v-card>  </v-flex>

            <v-card class="shadow-none" xs12 flat outlined>
                <Content v-if="qtype == 1" v-bind:dcontent='getDataInLang(getLanguagePrimary)' /> 
                <CType2 v-if="qtype == 2" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
                <CType3 v-if="qtype == 3" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
                <CType4 v-if="qtype == 4" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
                <CType5 v-if="qtype == 5" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
                <CType6 v-if="qtype == 6" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
                <CType7 v-if="qtype == 7" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
                <CType8 v-if="qtype == 8" v-bind:dcontent='getDataInLang(getLanguagePrimary)' v-bind:courseID='courseID'/> 
                <CType11 v-if="qtype == 11" v-bind:dcontent='getDataInLang(getLanguagePrimary)'/> 
            </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Content from '../preview/content.vue'
import CType2 from '../preview/CType2.vue'
import CType3 from '../preview/CType3.vue'
import CType4 from '../preview/CType4.vue'
import CType5 from '../preview/CType5.vue'
import CType6 from '../preview/CType6.vue'
import CType7 from '../preview/CType7.vue'
import CType8 from '../preview/CType8.vue'
import CType11 from '../preview/CType11.vue'
import LeftAdminBar from '../LeftAdminBar.vue'
import LanguageList from '../LanguageList.vue'
import axios from '../../../axios-auth.js'
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            dcontent: null,
            globals: null,
            qtype: 0,
            courseID: 0
        }
    },
    computed: 
        mapGetters([
                    'getLanguageChanged',
                    'getLanguagePrimary'
                    ])
    ,
    components: {
        Content,
        CType2,
        CType3,
        CType4,
        CType5,
        CType6,
        CType7,
        CType8,
        CType11,
        LeftAdminBar,
        LanguageList
    },
    mounted() {
        this.$store.commit('setFeedback', null)    
        // get lesson content
        axios.get('/get-task-in-all-lang/' + this.$route.params.id, this.$store.getters.getAxiosConfig )
        .then(res => {
            // set data to content
            this.$store.dispatch('setAdminBreadCrumbs',res.data) 
            this.courseID = res.data.course.id
            this.dcontent = res.data
            this.globals = res.data.globals
            this.qtype = res.data.task_type
        })
        .catch(error => {
          this.$store.commit('setFeedback', error)
      })
    }, 
    methods :{
        getDataInLang(lang) {
            for(var i = 0; i < this.dcontent.list.length; i++) {
                if (lang.id == this.dcontent.list[i].lang_id) {
                    
                    return { data: {
                                    content: this.dcontent.list[i].content,
                                    globals: this.globals
                                }
                        }
                }
            }
            return ''
        }
    }
}
</script>
